import { ApplicationJson } from '../base/httpclient';
import AuthApi from './_authApi';

class AccountApi extends AuthApi {
  constructor() {
    super();
  }
  controllerName = 'Accounts';

  /**
   * Lấy token làm việc
   * ndhieu3 19.06.2023
   *
   */
  getToken(payload) {
    let request = {
      url: [this.getAPIUrl(), '/token'].join(''),
      data: payload,
    };

    return this.getAsync(request);
  }

  /**
   * check tồn tại db trước, nếu tồn tại thì mới get token
   * @param {*} payload
   * nvxuan 23.11.2023
   */
  getTokenV2(payload) {
    let request = {
      url: [this.getAPIUrl(), '/token-v2'].join(''),
      data: payload,
    };

    return this.getAsync(request);
  }

  login() {
    const param = {url: [this.getAPIUrl(), 'login'].join('/'), data: {username: 'admin', password: '123456'}};
    return this.postAsync(param);
  }

  logout() {
    const param = {url: [this.getAPIUrl(), 'logout'].join('/'), data: {}};
    return this.getAsync(request, true, true, ApplicationJson, false);
  }
  /**
   * Đăng nhập
   */
  async loginCallback(model) {
    const request = {
      url: [this.getAPIUrl(), 'login-callback'].join('/'),
      data: model,
    };
    return this.getAsync(request, true, true, ApplicationJson, false);
  }

  /**
   *  Get link từ MisaID
   */
  async getMisaIdLink(payload) {
    const request = {
      url: [this.getAPIUrl(), 'get-misa-id-link'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * Lấy lịch sử thỏa thuận hoặc chính sách
   * @param {*} payload
   * pvdat1 28/02/2024
   */
  async getHistoryAgreement(payload) {
    const request = {
      url: [this.getAPIUrl(), 'history-agreement'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * Sự kiện đóng cảnh báo hết hạn
   * @param {*} payload
   * @returns
   * nvxuan 21.09.2023
   */
  async closeWarningDate(payload) {
    const request = {
      url: [this.getAPIUrl(), 'close-warning-date'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * Kiểm tra xem database với database_id có đang sao lưu dữ liệu hay không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện sao lưu không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện khôi phục dữ liệu không
   * nvxuan 20.11.2023
   */
  async checkBusyBackupRestore(dbId, userId) {
    const request = {
      url: [this.getAPIUrl(), 'check-busy-backup-restore'].join('/'),
      data: {
        database_id_old: dbId,
        user_id: userId,
      },
    };
    return this.postAsync(request);
  }

  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   */
  async recordNpsServey(payload) {
    const request = {
      url: [this.getAPIUrl(), 'record-nps-servey'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }
  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   */
  async recordNpsServeyProactive(payload) {
    const request = {
      url: [this.getAPIUrl(), 'record-nps-servey-proactive'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * Lấy quyền hạn mới của user (gọi từ WebSocket)
   * Giống MIMOSA: sysRoleAPI.getRole()
   * @param {Guid} userId - ID của user
   * @returns {Promise<Dictionary<string, List<int>>>} Permission dictionary
   */
  async getPermission(userId) {
    const request = {
      url: [this.getAPIUrl(), 'get-permission', userId].join('/'),
    };
    return this.getAsync(request);
  }
}

export default new AccountApi();
